import React from "react";
import ReactStreetview from "react-streetview";
import PopupComp from "../../components/PopupComp";
import constant from "../../constant";

const Streetview = props => {
  const options = {
    position: {
      lat: props.location.lat,
      lng: props.location.lng
    },
    pov: { heading: 100, pitch: 0 },
    zoom: 1
  };

  return (
    <PopupComp isPopup={props.handleStreetViewClick}>
      <h2 className="form-group">Street view listing!</h2>
      <div
        style={{
          width: "100%",
          height: "350px",
          backgroundColor: "#eeeeee"
        }}
      >
        <ReactStreetview
          apiKey={constant.googleMapsApiKey}
          streetViewPanoramaOptions={options}
        />
      </div>
    </PopupComp>
  );
};

export default Streetview;
